import { createFileRoute } from "@tanstack/react-router";
import AdminDatabaseDdlPage from "@/admin/pages/database-ddl";

export const Route = createFileRoute("/admin/database-ddl")({
  component: AdminDatabaseDdlPage,
});
